<mat-card class="ingestion-settings-card">
  <mat-card-header>
    <div class="header-content">
      <mat-icon class="header-icon">verified</mat-icon>
      <div class="header-text">
        <mat-card-title>Ingestion Settings</mat-card-title>
        <mat-card-subtitle>Configure optional processing features for page ingestion</mat-card-subtitle>
      </div>
    </div>
  </mat-card-header>

  @if (saving) {
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  }

  <mat-card-content>
    @if (error) {
      <div class="error-message">{{ error }}</div>
    }

    <div class="setting-row">
      <div class="setting-info">
        <span class="setting-name">Visual Verification</span>
        <span class="setting-description">
          Visually verify extracted transcripts against the rasterized PDF page. Corrections are applied automatically;
          originals are preserved.
        </span>
      </div>
      <mat-slide-toggle
        [checked]="visualVerificationEnabled"
        [disabled]="saving"
        (change)="onVisualVerificationToggle($event.checked)"
      ></mat-slide-toggle>
    </div>

    <div class="setting-row">
      <div class="setting-info">
        <span class="setting-name">Region Hierarchy Extraction</span>
        <span class="setting-description">
          Decompose each page into a hierarchy of regions and transcribe each from tight crops. Produces higher-fidelity
          transcripts than single-shot extraction.
        </span>
      </div>
      <mat-slide-toggle
        [checked]="regionHierarchyEnabled"
        [disabled]="saving"
        (change)="onRegionHierarchyToggle($event.checked)"
      ></mat-slide-toggle>
    </div>
  </mat-card-content>
</mat-card>
